import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CardGrafico } from './CardGrafico';
import { useChartTheme } from './ChartTheme';
import { fmtBRL, fmtBRLcompacto } from './formatadores';
import type { DashboardFinanceiro } from '../../types';

export function GraficoAging({ dados }: { dados: DashboardFinanceiro['aging'] }) {
  const t = useChartTheme();
  const data = [
    { faixa: 'A vencer', valor: dados.a_vencer, cor: t.recebido },
    { faixa: 'Até 30d', valor: dados.f0_30, cor: '#facc15' },
    { faixa: '31–60d', valor: dados.f31_60, cor: '#fb923c' },
    { faixa: '61–90d', valor: dados.f61_90, cor: '#f97316' },
    { faixa: '+90d', valor: dados.f90_mais, cor: '#dc2626' },
  ];
  const vazio = data.every((d) => d.valor <= 0);
  return (
    <CardGrafico titulo="A receber por vencimento" vazio={vazio} msgVazio="Nada a receber em aberto">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 16, left: 8, bottom: 0 }}>
          <XAxis type="number" tickFormatter={(v) => fmtBRLcompacto(v as number)} tick={{ fontSize: 11, fill: t.texto }} axisLine={false} tickLine={false} />
          <YAxis type="category" dataKey="faixa" tick={{ fontSize: 11, fill: t.texto }} axisLine={false} tickLine={false} width={64} />
          <Tooltip
            cursor={{ fill: t.grid, opacity: 0.3 }}
            formatter={(v: number) => [fmtBRL(v), 'A receber']}
            contentStyle={{ background: t.tooltipBg, border: `1px solid ${t.grid}`, borderRadius: 8, fontSize: 12, color: t.texto }}
          />
          <Bar dataKey="valor" radius={[0, 4, 4, 0]} maxBarSize={26}>
            {data.map((d, i) => <Cell key={i} fill={d.cor} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </CardGrafico>
  );
}
